module.exports = __webpack_public_path__ + "static/media/IMG_E3040a.4090d8cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cycle/andes/IMG_E3040a.jpg
// module id = 162
// module chunks = 0